const node = document.querySelector("#syscofy-auth-config");

export const config = node ? JSON.parse(node.textContent || "{}") : {};
export const labels = config.labels || {};
